import type React from 'react';

type AriaDisabled = React.AriaAttributes['aria-disabled'];

export const isAriaDisabled = (value: AriaDisabled): boolean => value === true || value === 'true';

export const guardedClick =
  <E extends React.SyntheticEvent>(inert: boolean, onClick: ((event: E) => void) | undefined) =>
  (event: E): void => {
    if (inert) {
      event.preventDefault();
      return;
    }
    onClick?.(event);
  };
